var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({
    'background-color': _vm.useBackgroundColor,
    'padding-top': _vm.paddingTop + 'px',
    'padding-bottom': _vm.paddingBottom + 'px'
  })},[_c('div',{class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl },on:{"click":function($event){return _vm.$emit('block:redirect')}}},[(_vm.useHeader)?_c('h3',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"inj-html el-tiptap-editor__content",domProps:{"innerHTML":_vm._s(_vm.mainFields.editor?.value)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }